<div [class.busy]="isBusy" [class.time-log]="canEdit">
  <app-data-grid
    [height]="canEdit ? height + 46 : height"
    [hasPaging]="false"
    [hasSearch]="false"
    [dataSource]="timeLog"
    [columns]="[
      { dataField: 'Date', caption: languageService.LNG('Label.Date'), dataType: 'date', format: 'EEE dd.MM.yy', validationRules: [{ type: 'required' }] },
      { dataField: 'EmployeeId', cellTemplate: employeeCellTemplate, caption: languageService.LNG('Label.Employee'), visible: canEdit, lookup: { dataSource: employees, valueExpr: 'EmployeeId', displayExpr: 'EmployeeNumberAndName' }, validationRules: [{ type: 'required' }], alignment: 'left' },
      { dataField: 'TimeTypeId', cellTemplate: timeTypeCellTemplate, caption: languageService.LNG('Label.TimeType'), visible: canEdit, lookup: { dataSource: timeTypes, valueExpr: 'TimeTypeId', displayExpr: 'Code' }, validationRules: [{ type: 'required' }] },
      { dataField: 'StartTimeTommss', caption: languageService.LNG('Label.Start'), width: 75, alignment: 'right', validationRules: [{ type: 'required' }] },
      { dataField: 'StopTimeTommss', caption: languageService.LNG('Label.Stop'), width: 75, alignment: 'right', validationRules: [{ type: 'required' }] },
      { dataField: 'SecondsToHHmm', cellTemplate: timeCellTemplate, caption: languageService.LNG('Label.Hours.Minutes.Short'), width: 75, alignment: 'right', allowEditing: false }
    ]"
    [allowAdding]="canEdit"
    [allowUpdating]="canEdit && selectedTimeRecord !== undefined && selectedTimeRecord !== null"
    [allowDeleting]="canEdit && selectedTimeRecord !== undefined && selectedTimeRecord !== null"
    [useDefaultUpdateEmitter]="true"
    (cellPrepared)="onCellPrepared($event)"
    (rowInsertingWithEvent)="onRowInserting($event)"
    (rowUpdating)="onRowUpdating($event)"
    (rowRemovingWithEvent)="onRowRemoving($event)"
    (initNewRow)="onInitNewRow($event)"
    (editorPreparing)="onEditorPreparing($event)">
  </app-data-grid>
</div>